import { render, staticRenderFns } from "./AllModals.vue?vue&type=template&id=6d28ed50&scoped=true"
import script from "./AllModals.vue?vue&type=script&lang=js"
export * from "./AllModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d28ed50",
  null
  
)

export default component.exports